import { orchestrator } from "satcheljs";
import { onOpenAppPane } from "owa-app-pane-group-actions";
import getDrawerPaneId from "owa-app-pane-group-utils/lib/getDrawerPaneId";
import openAppPane from "./openAppPane";

orchestrator(onOpenAppPane, ({ appPaneName, targetWindow }) => {
    openAppPane(getDrawerPaneId(appPaneName), targetWindow);
});
